import { render, staticRenderFns } from "./authentication-wrapper.vue?vue&type=template&id=7260800a&"
import script from "./authentication-wrapper.vue?vue&type=script&lang=js&"
export * from "./authentication-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports